<template>
  <div class="row">
    <div class="col-12 active">
      <div class="card active">
        <div class="card-body mini-nav bg-primary pt-2 pb-3 active">
          <nav class="navbar navbar-expand-md navbar navbar-dark bg-primary py-2 active">
            <button
                class="navbar-toggler btn btn-sm px-3 font-size-16 header-item waves-effect h-auto text-primary"
                type="button"
                data-toggle="collapse"
                data-target="#navbarNavAltMarkup"
                aria-controls="navbarNavAltMarkup"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
              <span class="mdi mdi-menu"></span>
            </button>
            <div class="collapse navbar-collapse justify-content-between active" id="navbarNavAltMarkup">
              <div class="navbar-nav active">
                <a
                    class="nav-item nav-link"
                    :class="{ active: selectedSub === 'valuation-dashboard' }"
                    @click="gotTo('valuation-dashboard')"
                >
                  Dashboard
                </a>
                <a
                    class="nav-item nav-link"
                    :class="{ active: selectedSub === 'valuation-properties' }"
                    @click="gotTo('valuation-properties')"
                >
                  Properties
                </a>
                <a
                    class="nav-item nav-link"
                    :class="{ active: selectedSub === 'valuation-requests' }"
                    @click="gotTo('valuation-requests')"
                >
                  Update Requests
                </a>
                <a
                    class="nav-item nav-link"
                    :class="{ active: selectedSub === 'valuation-walk-in' }"
                    @click="gotTo('valuation-walk-in')"
                >
                  Walk-in Service
                </a>
                <a
                    class="nav-item nav-link"
                    :class="{ active: selectedSub === 'valuation-approvals' }"
                    @click="gotTo('valuation-approvals')"
                >
                  Approvals
                </a>

              </div>
              <div class="navbar-nav text-capitalize">
                <h4 class="mb-0 m-0 card-title text-white">{{getPageTitle()}}</h4>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ToolBarValuation",
  data() {
    return {
      selectedSub: null,
    };
  },
  mounted() {
    this.selectedSub = sessionStorage.getItem("selectedSub") || this.$route.name;
  },
  methods: {
    gotTo(route) {
      this.selectedSub = route;
      this.$router.push(route);
      sessionStorage.setItem("selectedSub", route);
    },

    getPageTitle() {
      const titles = {
        'valuation-dashboard': 'Valuation Roll Dashboard',
        'valuation-properties': 'Property Management',
        'valuation-requests': 'Update Requests Management',
        'valuation-walk-in': 'Walk-in Customer Service',
        'valuation-approvals': 'Approval Management',
        'valuation-reports': 'Valuation Roll Reports',
        'valuation-transfers': 'Property Transfers',
        'valuation-subdivisions': 'Property Subdivisions'
      };
      return titles[this.selectedSub] || 'Valuation Roll Management';
    }
  },
  watch: {
    '$route'(to) {
      this.selectedSub = to.name;
      sessionStorage.setItem("selectedSub", to.name);
    }
  }
};
</script>

<style scoped></style>